import {type Type, Plugins} from '@packages/systems/wfdl';
import {typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {emptyObject} from '@packages/utilities/fp/utils';

export const migrateEnumDataType = (dataTypeJson: any) => {
  if (dataTypeJson && dataTypeJson.type === 'Enum') {
    const newDataType: Type = {
      type: 'TypeApplication',
      val: {
        con: {
          type: 'TypeConstructor',
          val: qualify(Plugins.name('Builtin'), typeName('Enum')),
        },
        // @ts-expect-error - TS2322 - Type '[string, unknown]' is not assignable to type 'Type'.
        arg: Object.entries(dataTypeJson.values || emptyObject).reduce(
          // @ts-expect-error - TS2769 - No overload matches this call.
          (row, [key, value]: [any, any]) => {
            const {label, ...rest} = value;
            return {
              type: 'RowCons',
              val: {
                label: key,
                type: {
                  type: 'TypeApplication',
                  val: {
                    con: {
                      type: 'TypeConstructor',
                      val: qualify(Plugins.name('Builtin'), typeName('Record')),
                    },
                    arg: {
                      type: 'RowEmpty',
                    },
                  },
                },
                tail: row,
              },
              system: {label},
              meta: {...rest},
            };
          },
          {type: 'RowEmpty'}
        ),
      },
    };

    if (dataTypeJson.system) newDataType.system = dataTypeJson.system;
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};
